'use client';
import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

import {
  type DynamicFilterMessages,
  dynamicFilterMessagesAtom,
} from 'Atoms/App/Plp/DynamicFilterMessagesAtom';

export default function PlpPage({
  filtersList,
  strings,
  children,
}: {
  filtersList: Filter[];
  strings: DynamicFilterMessages;
  children?: React.ReactNode;
}): React.ReactNode {
  const setDynamicFilterMessages = useSetAtom(dynamicFilterMessagesAtom);

  const setFiltersList = useSetAtom(filtersListAtom);
  useEffect(() => {
    setDynamicFilterMessages(strings);
    setFiltersList(filtersList);
  }, [filtersList]);
  return children ?? null;
}
